import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Shared 404 page.
 *
 * This is also what an operator sees when they lack can_view_user_details, so
 * the copy must never mention permissions or access. Saying "you are not
 * allowed" would confirm the page exists, which is exactly what a 404 is
 * chosen over a 403 to avoid.
 */
function NotFound() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" sx={{ fontWeight: 600, color: 'primary.main' }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ mt: 1, mb: 2 }}>
          Page not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          The page you are looking for does not exist.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard')}>
          Back to dashboard
        </Button>
      </Box>
    </Container>
  );
}

export default NotFound;
